import { render, staticRenderFns } from "./LoaderDots.vue?vue&type=template&id=bc0bdd8a&scoped=true"
import script from "./LoaderDots.vue?vue&type=script&lang=js"
export * from "./LoaderDots.vue?vue&type=script&lang=js"
import style0 from "./LoaderDots.vue?vue&type=style&index=0&id=bc0bdd8a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0bdd8a",
  null
  
)

export default component.exports